import React, { ReactNode, useState } from 'react';
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';
import { IconButton, Paper, Popover } from '@mui/material';

interface Props {
  readonly children: ReactNode;
}

export function HelpButton({ children }: Props) {
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLElement | null>(null);
  const popoverIsOpen = !!popoverAnchor;

  return (
    <>
      <IconButton size="small" onClick={(event) => setPopoverAnchor(event.currentTarget)}>
        <HelpIcon />
      </IconButton>

      <Popover
        open={popoverIsOpen}
        anchorEl={popoverAnchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={() => setPopoverAnchor(null)}
      >
        <Paper sx={{ p: 2, maxWidth: '500px' }}>{children}</Paper>
      </Popover>
    </>
  );
}
